import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AdminTitle, DataTable, Stat } from "@/pages/admin/AdminLayout";
import { Badge } from "@/pages/Account";
import { Spinner, Empty } from "@/components/site/Bits";
import { useApi, fmtDateTime, fmtPrice } from "@/lib/api";

export default function Payments() {
  const api = useApi();
  const [status, setStatus] = useState("all");
  const [list, setList] = useState(null);
  useEffect(() => {
    api("get", "/admin/payments", null, { params: { status: status === "all" ? "" : status } }).then(setList);
  }, [api, status]);
  const paid = (list || []).filter((p) => p.status === "paid");
  return (
    <div data-testid="admin-payments">
      <AdminTitle title="إدارة المدفوعات">
        <Select value={status} onValueChange={setStatus} dir="rtl">
          <SelectTrigger className="w-44 bg-white" data-testid="payments-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">كل الحالات</SelectItem><SelectItem value="paid">مدفوع</SelectItem><SelectItem value="initiated">قيد الدفع</SelectItem>
            <SelectItem value="failed">فشل</SelectItem><SelectItem value="expired">منتهية</SelectItem>
          </SelectContent>
        </Select>
      </AdminTitle>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <Stat label="عدد العمليات" value={list?.length ?? "—"} testId="payments-count" />
        <Stat label="العمليات الناجحة" value={paid.length} testId="payments-paid-count" />
        <Stat label="إجمالي المبالغ المحصلة" value={fmtPrice(paid.reduce((a, p) => a + p.amount, 0))} testId="payments-paid-total" />
      </div>
      {!list ? <Spinner /> : !list.length ? <Empty text="لا توجد عمليات" /> : (
        <DataTable head={["رقم المعاملة", "رقم التسجيل", "المتدرب", "الدورة", "المبلغ", "الوسيلة", "الحالة", "تاريخ الإنشاء", "تاريخ الدفع"]} testId="payments-table">
          {list.map((p) => (
            <tr key={p.id} data-testid={`payment-row-${p.ref}`}>
              <td className="font-mono text-xs" dir="ltr">{p.ref}</td><td className="font-mono text-xs" dir="ltr">{p.reg_no}</td>
              <td>{p.student_name}</td><td className="max-w-[200px] truncate">{p.course_title}</td>
              <td className="whitespace-nowrap">{fmtPrice(p.amount)}{p.coupon_code && <div className="text-[11px] text-emerald-700" data-testid={`payment-coupon-${p.ref}`}>قسيمة {p.coupon_code} (−{fmtPrice(p.discount)})</div>}</td><td className="text-xs whitespace-nowrap" data-testid={`payment-provider-${p.ref}`}>{{ paymob: "Paymob", coupon: "قسيمة", thawani: "ثواني (قديم)" }[p.provider] || p.provider}</td><td><Badge s={p.status} /></td>
              <td className="whitespace-nowrap text-xs">{fmtDateTime(p.created_at)}</td><td className="whitespace-nowrap text-xs">{fmtDateTime(p.paid_at)}</td>
            </tr>
          ))}
        </DataTable>
      )}
    </div>
  );
}
